module.exports = __webpack_public_path__ + "img/lingbaoAppImage.cc1522b9.png";